import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Registra una visita sul backend ad ogni cambio route.
 * Silenzioso: nessuna UI. Il conteggio è visibile solo all'admin.
 */
export default function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname || "/";
    // Non tracciare pagine admin/preview riservate
    if (path.startsWith("/admin") || path.startsWith("/preventivo/")) return;
    api.post("/track/visit", { path }).catch(() => {
      /* silenzioso */
    });
  }, [location.pathname]);
  return null;
}
